// extracted by mini-css-extract-plugin
export default {"Main":"Static_Main__irnvC","Wrapper":"Static_Wrapper__2+c+X","li":"Static_li__odj1y","h6":"Static_h6__QZ0Cj","padding":"Static_padding__r-s6f"};